'use client';

import { useEffect } from 'react';

export default function Error({
                                  error,
                                  reset,
                              }: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('Error in offerta-last-minute page:', error);
    }, [error]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <h2 className="text-2xl font-bold mb-4">Qualcosa è andato storto!</h2>
            <p className="text-gray-600 mb-4">
                Si è verificato un errore durante il caricamento delle offerte.
            </p>
            <button
                onClick={reset}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
                Riprova
            </button>
        </div>
    );
}
